export const MUTUALLY_EXCLUSIVE_NEWS_TRADING_RULES = [
  'HIGH_IMPACT_NEWS_TRADING_FXSTREET',
  'HIGH_IMPACT_NEWS_TRADING_FOREX_FACTORY',
];

/** Rule types enabled by presence only (no extra input); sent to API as value 1. */
export const TOGGLE_RULE_TYPES = [
  'OVERNIGHT',
  'POSITIVE_BALANCE',
  'POSITIVE_EQUITY',
  'HIGH_IMPACT_NEWS_TRADING_FXSTREET',
  'HIGH_IMPACT_NEWS_TRADING_FOREX_FACTORY',
  'NO_MID_COMPETITION_DEPOSITS',
];

/** i18n keys for the dynamic (backend-defined) rule types, shared by the rules and preset steps. */
export const RULE_LABEL_KEYS = {
  CONSISTENCY: 'rules_TournamentRules.dynamic.consistency',
  MAX_AGGREGATED_TRADE_SIZE: 'rules_TournamentRules.dynamic.maxAggregatedTradeSize',
  MAX_DAILY_LOSS_EOD: 'rules_TournamentRules.dynamic.maxDailyLossEod',
  MAX_DRAWDOWN_BL_PT: 'rules_TournamentRules.dynamic.maxBalanceDrawdownPercent',
  MAX_DRAWDOWN_EQ_PT: 'rules_TournamentRules.dynamic.maxEquityDrawdownPercent',
  MAX_TRADE_SIZE: 'rules_TournamentRules.dynamic.maxTradeSizeLots',
  MIN_AGGREGATED_TRADE_SIZE: 'rules_TournamentRules.dynamic.minAggregatedTradeSizeLots',
  MIN_TRADABLE_DAYS: 'rules_TournamentRules.dynamic.minTradingDaysDays',
  MIN_TRADES: 'rules_TournamentRules.dynamic.minTrades',
  MIN_TRADE_SIZE: 'rules_TournamentRules.dynamic.minTradeSizeLots',
  OVERNIGHT: 'rules_TournamentRules.dynamic.overnightRestriction',
  POSITIVE_BALANCE: 'rules_TournamentRules.dynamic.positiveBalance',
  POSITIVE_EQUITY: 'rules_TournamentRules.dynamic.positiveEquity',
  HIGH_IMPACT_NEWS_TRADING_FXSTREET: 'rules_TournamentRules.dynamic.highImpactNewsTradingRestrictionFxstreet',
  HIGH_IMPACT_NEWS_TRADING_FOREX_FACTORY: 'rules_TournamentRules.dynamic.highImpactNewsTradingRestrictionForexFactory'
};

/** Rule types whose value is a ratio (0.3 = 30%) — displayed as a percentage. */
export const PERCENTAGE_RULE_TYPES = [
  'CONSISTENCY',
  'MAX_DAILY_LOSS_EOD',
  'MAX_DRAWDOWN_BL_PT',
  'MAX_DRAWDOWN_EQ_PT',
  'MAX_DRAWDOWN_RT',
];

export function isToggleRuleType(type, dynamicRule) {
  if (dynamicRule && dynamicRule.dataType === 'BOOLEAN') {
    return true;
  }
  return TOGGLE_RULE_TYPES.includes(type);
}

export function formatTournamentRuleValueForApi(rule) {
  if (TOGGLE_RULE_TYPES.includes(rule.type) || rule.value === true || rule.value === 'true') {
    return 1;
  }
  const parsed = parseFloat(rule.value);
  return Number.isNaN(parsed) ? 0 : parsed;
}

/**
 * Converts a competition preset rule (CompetitionPresetRuleDTO: ruleType +
 * value) into the wizard's form representation used by TournamentRules.vue.
 * Values are stored the way the API expects them (ratios for percentages), so
 * the rules step keeps validating and editing them like user-entered rules.
 */
export function presetRuleToFormRule(presetRule) {
  const type = presetRule.ruleType;
  const isToggle = TOGGLE_RULE_TYPES.includes(type);
  return {
    type,
    value: isToggle ? true : String(presetRule.value != null ? presetRule.value : ''),
    error: '',
    isDirty: true,
    isEditing: false
  };
}
